import type { FortuneIconProps } from '@/app_components/icons/constants';

export const Instagram = ({ className, ...props }: FortuneIconProps) => {
  return (
    <svg
      className={className}
      height='20'
      stroke='none'
      viewBox='0 0 20 20'
      width='20'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <title>Instagram icon</title>
      <mask
        height='20'
        id='mask0_279_37829'
        maskUnits='userSpaceOnUse'
        style={{ maskType: 'alpha' }}
        width='20'
        x='0'
        y='0'
      >
        <rect
          fill='#D9D9D9'
          height='20'
          width='20'
        />
      </mask>
      <g mask='url(#mask0_279_37829)'>
        <path
          d='M0 14.1026C0 17.3588 2.64124 20 5.89744 20H14.1026C17.3588 20 20 17.3588 20 14.1026V5.89744C20 2.64124 17.3588 0 14.1026 0H5.89744C2.64124 0 0 2.64124 0 5.89744V14.1026ZM15.3846 3.58974C16.1028 3.58974 16.6667 4.15365 16.6667 4.87179C16.6667 5.58994 16.1028 6.15385 15.3846 6.15385C14.6665 6.15385 14.1026 5.58994 14.1026 4.87179C14.1026 4.15365 14.6665 3.58974 15.3846 3.58974ZM10 5.1282C12.6923 5.1282 14.8718 7.30769 14.8718 10C14.8718 12.6923 12.6923 14.8718 10 14.8718C7.30769 14.8718 5.1282 12.6923 5.1282 10C5.1282 7.30769 7.30769 5.1282 10 5.1282Z'
          fill='currentColor'
        />
        <path
          d='M13.3333 10C13.3333 11.8409 11.8409 13.3333 10 13.3333C8.15906 13.3333 6.66667 11.8409 6.66667 10C6.66667 8.15906 8.15906 6.66667 10 6.66667C11.8409 6.66667 13.3333 8.15906 13.3333 10Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
};
